import { useCallback, useState } from 'react';
import { genValorNombreEvento } from '../../common/defaults';

function useBoolean(valorInicial, { generarValorNombre } = { generarValorNombre: genValorNombreEvento }) {
   const [estado, setEstado] = useState(valorInicial);

   const genValorNombre = useCallback(event => {
      return generarValorNombre(event);
   }, [generarValorNombre]);

   const toggle = useCallback(
      nombre => {
         if (typeof valorInicial === 'boolean') {
            setEstado(!estado);
         } else {
            setEstado({ ...estado, [nombre]: !estado[nombre] });
         }
      },
      [estado]
   );

   const setTrue = useCallback(
      nombre => {
         if (typeof valorInicial === 'boolean') {
            setEstado(true);
         } else {
            setEstado({ ...estado, [nombre]: true });
         }
      },
      [estado]
   );

   const setFalse = useCallback(
      nombre => {
         if (typeof valorInicial === 'boolean') {
            setEstado(false);
         } else {
            setEstado({ ...estado, [nombre]: false });
         }
      },
      [estado]
   );

   const handleBoolChange = useCallback(event => {
      const nombreValor = genValorNombre(event);
      if (typeof valorInicial === 'boolean') {
         setEstado(nombreValor.value);
      } else {
         setEstado({ ...estado, [nombreValor.name]: nombreValor.value });
      }
   }, [genValorNombre, estado]);

   return [estado, { toggle, setFalse, setTrue, setBoolean: setEstado, handleBoolChange }];
}

export default useBoolean;
